import { HeroVehicleSection } from "@/components/heros/section-hero-vehicle";
import { AboutTransportHomeSection } from "@/components/sections/section-about-home";
import { BannerSection } from "@/components/sections/section-banner";
import { BlogSection } from "@/components/sections/section-blog";
import { ColetaPersonalizadaSection } from "@/components/sections/section-coleta-personalizada";
import { ReembolsoIntegralSection } from "@/components/sections/section-integral-reembolso";
import { JourneySection } from "@/components/sections/section-journey";
import { ModalidadeTransporteSection } from "@/components/sections/section-modalidade-transporte";

import { PlataformaDigitalSection } from "@/components/sections/section-plataforma-digital";
import { RastreamentoTempoRealSection } from "@/components/sections/section-rastreamento-tempo-real";
import { RedeNacionalSection } from "@/components/sections/section-rede-nacional";
import { SegurosSection } from "@/components/sections/section-seguro";

import { AboutSection } from "@/components/sections/section-about";
import { CertificationSection } from "@/components/sections/section-certification";
import { StatsSectionClear } from "@/components/sections/section-stats-clear";
import { TestimonialSection } from "@/components/sections/section-testimonial";
import { TransportSection } from "@/components/sections/section-transport";
export default function TipoDeVeiculoPage() {
  return (
    <div className="min-h-screen bg-n-bg-1">
      <HeroVehicleSection />

      <TransportSection />

      <AboutTransportHomeSection />

      <ModalidadeTransporteSection />

      <StatsSectionClear />

      <JourneySection />

      <ColetaPersonalizadaSection />

      <RedeNacionalSection />

      <RastreamentoTempoRealSection />

      <SegurosSection />

      <ReembolsoIntegralSection />

      <PlataformaDigitalSection />

      <TestimonialSection />

      <CertificationSection />

      <BlogSection />

      <AboutSection />

      <BannerSection />
    </div>
  );
}
